import { Injectable } from '@angular/core';
import { type StorageKeys } from '@core/utils/storage-keys.util';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  setItem<T>(storageKey: StorageKeys, value: T): void {
    localStorage.setItem(storageKey, JSON.stringify(value));
  }

  getItem<T>(storageKey: StorageKeys): T | null {
    const item = localStorage.getItem(storageKey);
    return item ? JSON.parse(item) : null;
  }

  removeItem(storageKey: StorageKeys): void {
    localStorage.removeItem(storageKey);
  }

  clear(): void {
    localStorage.clear();
  }
}
